import React from "react";
import "./Name.css";

export default function Name() {
  return (
    <footer>
      This website was coded by{" "}
      <em>
        <a
          href="https://marinesimon.netlify.app/certificates.html"
          target="_blank"
          rel="noreferrer"
        >
          Marine Simon
        </a>
      </em>{" "}
      and is{" "}
      <em>
        <a
          href="https://github.com/Marines17/Dictionary-React"
          target="_blank"
          rel="noreferrer"
        >
          open sourced
        </a>
        .
      </em>
    </footer>
  );
}
